import { render, staticRenderFns } from "./PurInvoiceList.vue?vue&type=template&id=e5667c90&scoped=true&"
import script from "./PurInvoiceList.vue?vue&type=script&lang=js&"
export * from "./PurInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./PurInvoiceList.vue?vue&type=style&index=0&id=e5667c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5667c90",
  null
  
)

export default component.exports